import configApiCreater from './config';
import formApiCreater from './form';
import modelApiCreater from './model';
import orderApiCreater from './order';
import toolApiCreater from './tool';

const appApiCreater = (api, metadata, highlighter) => ({
  config: configApiCreater(metadata),
  model: modelApiCreater(api, highlighter),
  order: orderApiCreater(api),
  tool: toolApiCreater(metadata),
  form: formApiCreater(metadata),
});

export default appApiCreater;



// WEBPACK FOOTER //
// ./src/modules/index.js